// extracted by mini-css-extract-plugin
module.exports = {"opt-out-link":"optOutLink_opt-out-link__Ik_Mn","opt-out-link-text":"optOutLink_opt-out-link-text__2ofj7","table-cell":"optOutLink_table-cell__1kZyE"};